// src/hooks/usePlatform.js
import { useEffect, useState } from "react";
import { detectPlatform } from "../utils/platform";

export default function usePlatform() {
  const [platform, setPlatform] = useState("unknown");

  useEffect(() => {
    setPlatform(detectPlatform());
  }, []);

  return platform; // "ios" | "android" | "desktop" | "unknown"
}
